import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=7c3da8a4&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"
import style0 from "./TagView.vue?vue&type=style&index=0&id=7c3da8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3da8a4",
  null
  
)

export default component.exports